export const ZOOM_SLIDER_TRACK_SIZE = 8;
export const ZOOM_SLIDER_ACTIVE_TRACK_SIZE = 10;
export const ZOOM_SLIDER_THUMB_HEIGHT = 20;
export const ZOOM_SLIDER_THUMB_WIDTH = 10;

export const ZOOM_SLIDER_SIZE = Math.max(
  ZOOM_SLIDER_TRACK_SIZE,
  ZOOM_SLIDER_ACTIVE_TRACK_SIZE,
  ZOOM_SLIDER_THUMB_HEIGHT,
  ZOOM_SLIDER_THUMB_WIDTH,
);
